"use client";

import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Filter } from "lucide-react";
import { useAppDispatch, useAppSelector } from "@/hooks/useAppSelector";
import { FilterSubCategory } from "@/types/home";
import { addFilter, removeFilter } from "@/store/slices/stepSlice";
import { trackEvent } from "@/lib/gtag";
import { cn } from "@/lib/utils";

const MobileCategoryFilter = () => {
  const [open, setOpen] = useState(false);
  const { subCategories } = useAppSelector((state) => state.home);
  const { selectedFilters } = useAppSelector((state) => state.steps);
  const dispatch = useAppDispatch();

  const handleToggle = (item: FilterSubCategory) => {
    const isSelected = selectedFilters.some((f) => f.sc_id === item.sc_id);

    if (isSelected) {
      dispatch(removeFilter(item.sc_id));
      trackEvent({
        action: "filter_remove",
        category: "category_filter",
        label: `Removed Filter: ${item.SubcategorieName}`,
      });
    } else {
      dispatch(addFilter(item));
      trackEvent({
        action: "filter_apply",
        category: "category_filter",
        label: `Applied Filter: ${item.SubcategorieName}`,
      });
    }
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="h-9 px-3 text-sm flex items-center gap-1">
          <Filter className="w-4 h-4 text-black-1" />
          <span className="hidden sm:inline">Filter</span>
          {selectedFilters.length > 0 && (
            <Badge variant="secondary" className="ml-1 text-black-1 text-xs px-1.5 py-0.5">
              {selectedFilters.length}
            </Badge>
          )}
        </Button>
      </PopoverTrigger>

      <PopoverContent className="w-72 p-4 rounded-lg shadow-lg">
        <ScrollArea className="max-h-[250px] pr-1">
          <div className="flex flex-wrap gap-2">
            {subCategories?.map((item) => {
              const isSelected = selectedFilters.some((f) => f.sc_id === item.sc_id);

              return (
                <Button
                  key={item.sc_id}
                  variant="outline"
                  size="sm"
                  className={cn(
                    "text-xs font-medium rounded-full",
                    isSelected
                      ? "bg-blue-100 text-gray-700 border-gray-600"
                      : "text-gray-600"
                  )}
                  onClick={() => handleToggle(item)}
                >
                  {item.SubcategorieName}
                </Button>
              );
            })}
          </div>
        </ScrollArea>
      </PopoverContent>
    </Popover>
  );
};

export default MobileCategoryFilter;
